export const LE_AGENT_HUB_ROOT_ROUTE = '/agent-hub'
export const LE_AGENT_HUB_SIGNUP_ROUTE = '/agent-hub/signup'
